export var ActivityStatusType;
(function (ActivityStatusType) {
    ActivityStatusType[ActivityStatusType["SUCCESS"] = 1] = "SUCCESS";
    ActivityStatusType[ActivityStatusType["RECEIVED"] = 2] = "RECEIVED";
    ActivityStatusType[ActivityStatusType["SENT"] = 3] = "SENT";
    ActivityStatusType[ActivityStatusType["EXPIRED"] = 4] = "EXPIRED";
    ActivityStatusType[ActivityStatusType["CANCELED"] = 5] = "CANCELED";
})(ActivityStatusType || (ActivityStatusType = {}));
export var ActivityNewMemberBonusStateType;
(function (ActivityNewMemberBonusStateType) {
    ActivityNewMemberBonusStateType["JOINED"] = "joined";
    ActivityNewMemberBonusStateType["BONUS_RECEIVED"] = "bonus_received";
    ActivityNewMemberBonusStateType["BONUS_EXPIRED"] = "bonus_expired";
    ActivityNewMemberBonusStateType["CANCELED"] = "cancelled";
})(ActivityNewMemberBonusStateType || (ActivityNewMemberBonusStateType = {}));
export var ActivityDailySignInStateType;
(function (ActivityDailySignInStateType) {
    ActivityDailySignInStateType["APPLIED"] = "applied";
    ActivityDailySignInStateType["RECEIVED"] = "received";
    ActivityDailySignInStateType["EXPIRED"] = "expired";
    ActivityDailySignInStateType["CANCELED"] = "canceled";
})(ActivityDailySignInStateType || (ActivityDailySignInStateType = {}));
export var ActivityNewYear2023StatusType;
(function (ActivityNewYear2023StatusType) {
    ActivityNewYear2023StatusType["NO_USE"] = "no_use";
    ActivityNewYear2023StatusType["RECEIVED"] = "received";
    ActivityNewYear2023StatusType["EXPIRED"] = "expired";
})(ActivityNewYear2023StatusType || (ActivityNewYear2023StatusType = {}));
export var ActivityDragonBoatFestival2023StatusType;
(function (ActivityDragonBoatFestival2023StatusType) {
    ActivityDragonBoatFestival2023StatusType["NO_USE"] = "no_use";
    ActivityDragonBoatFestival2023StatusType["RECEIVED"] = "received";
    ActivityDragonBoatFestival2023StatusType["LOST"] = "lost";
    ActivityDragonBoatFestival2023StatusType["EXPIRED"] = "expired";
    ActivityDragonBoatFestival2023StatusType["CANCELED"] = "canceled";
})(ActivityDragonBoatFestival2023StatusType || (ActivityDragonBoatFestival2023StatusType = {}));
export var ActivityNewYear2024StatusType;
(function (ActivityNewYear2024StatusType) {
    ActivityNewYear2024StatusType["RECEIVED"] = "received";
    ActivityNewYear2024StatusType["LOST"] = "lose";
})(ActivityNewYear2024StatusType || (ActivityNewYear2024StatusType = {}));
export var ActivityNewYear2025DrawStatusType;
(function (ActivityNewYear2025DrawStatusType) {
    ActivityNewYear2025DrawStatusType["NO_USE"] = "no_use";
    ActivityNewYear2025DrawStatusType["NOT_RECEIVED"] = "not_received";
    ActivityNewYear2025DrawStatusType["RECEIVED"] = "received";
    ActivityNewYear2025DrawStatusType["LOSE"] = "lose";
    ActivityNewYear2025DrawStatusType["EXPIRED"] = "expired";
})(ActivityNewYear2025DrawStatusType || (ActivityNewYear2025DrawStatusType = {}));
export var ActivityNewYear2025RedEnvelopeStatusType;
(function (ActivityNewYear2025RedEnvelopeStatusType) {
    ActivityNewYear2025RedEnvelopeStatusType["NO_USE"] = "no_use";
    ActivityNewYear2025RedEnvelopeStatusType["NOT_RECEIVED"] = "not_received";
    ActivityNewYear2025RedEnvelopeStatusType["RECEIVED"] = "received";
    ActivityNewYear2025RedEnvelopeStatusType["EXPIRED"] = "expired";
})(ActivityNewYear2025RedEnvelopeStatusType || (ActivityNewYear2025RedEnvelopeStatusType = {}));
export var ActivityNewYearDrawStatusType;
(function (ActivityNewYearDrawStatusType) {
    ActivityNewYearDrawStatusType["NO_USE"] = "no_use";
    ActivityNewYearDrawStatusType["NOT_RECEIVED"] = "not_received";
    ActivityNewYearDrawStatusType["RECEIVED"] = "received";
    ActivityNewYearDrawStatusType["LOSE"] = "lose";
    ActivityNewYearDrawStatusType["EXPIRED"] = "expired";
})(ActivityNewYearDrawStatusType || (ActivityNewYearDrawStatusType = {}));
export var ActivityDepositBonusStatusType;
(function (ActivityDepositBonusStatusType) {
    ActivityDepositBonusStatusType["RECEIVED"] = "received";
})(ActivityDepositBonusStatusType || (ActivityDepositBonusStatusType = {}));
export var ActivityUefaBuildingUpStateType;
(function (ActivityUefaBuildingUpStateType) {
    ActivityUefaBuildingUpStateType["APPLIED"] = "applied";
    ActivityUefaBuildingUpStateType["RECEIVED"] = "received";
    ActivityUefaBuildingUpStateType["CANCELED"] = "cancelled";
    ActivityUefaBuildingUpStateType["EXPIRED"] = "expired";
})(ActivityUefaBuildingUpStateType || (ActivityUefaBuildingUpStateType = {}));
export var ActivityUefaStarsStatusType;
(function (ActivityUefaStarsStatusType) {
    ActivityUefaStarsStatusType["NO_USE"] = "no_use";
    ActivityUefaStarsStatusType["WIN"] = "win";
    ActivityUefaStarsStatusType["LOST"] = "lose";
    ActivityUefaStarsStatusType["EXPIRED"] = "expired";
    ActivityUefaStarsStatusType["RECEIVED"] = "received";
    ActivityUefaStarsStatusType["NOT_RECEIVED"] = "not_received";
})(ActivityUefaStarsStatusType || (ActivityUefaStarsStatusType = {}));
export var ActivityWeeklyBonusDrawStatusType;
(function (ActivityWeeklyBonusDrawStatusType) {
    ActivityWeeklyBonusDrawStatusType["EXPIRED"] = "expired";
    ActivityWeeklyBonusDrawStatusType["RECEIVED"] = "received";
    ActivityWeeklyBonusDrawStatusType["NOT_RECEIVED"] = "not_received";
})(ActivityWeeklyBonusDrawStatusType || (ActivityWeeklyBonusDrawStatusType = {}));
export var ActivityDailyBonusDrawStatusType;
(function (ActivityDailyBonusDrawStatusType) {
    ActivityDailyBonusDrawStatusType["EXPIRED"] = "expired";
    ActivityDailyBonusDrawStatusType["RECEIVED"] = "received";
    ActivityDailyBonusDrawStatusType["NOT_RECEIVED"] = "not_received";
})(ActivityDailyBonusDrawStatusType || (ActivityDailyBonusDrawStatusType = {}));
export var ActivityInviteFriendStatusType;
(function (ActivityInviteFriendStatusType) {
    ActivityInviteFriendStatusType["INIT"] = "init";
    ActivityInviteFriendStatusType["CLAIMED"] = "claimed";
    ActivityInviteFriendStatusType["EXPIRED"] = "expired";
})(ActivityInviteFriendStatusType || (ActivityInviteFriendStatusType = {}));
export var ActivityNewYearStatusType;
(function (ActivityNewYearStatusType) {
    ActivityNewYearStatusType["NO_USE"] = "no_use";
    ActivityNewYearStatusType["NOT_RECEIVED"] = "not_received";
    ActivityNewYearStatusType["RECEIVED"] = "received";
    ActivityNewYearStatusType["LOSE"] = "lose";
    ActivityNewYearStatusType["EXPIRED"] = "expired";
})(ActivityNewYearStatusType || (ActivityNewYearStatusType = {}));
//# sourceMappingURL=ActivityStatusType.js.map